<script setup lang="ts">
import { VERSION } from '@cinqo/common'
import { RotateCcwIcon } from 'lucide-vue-next'
import { hotReload } from '~/helpers/UtilsHelper'

async function hotReloadApp() {
  await hotReload()
}
</script>

<template>
  <div class="h-full w-full flex flex-col lg:flex-row">
    <!-- Mobile header skeleton (visible on mobile only) -->
    <div class="lg:hidden w-full bg-base-200 p-4 flex items-center justify-between">
      <div class="skeleton h-8 w-24" />
      <div class="skeleton h-8 w-8 rounded-full" />
    </div>

    <!-- Desktop sidebar skeleton (hidden on mobile) -->
    <div class="hidden lg:flex h-full w-60 bg-base-200 p-4 flex-col gap-4">
      <div class="skeleton h-10 w-40 mb-8" />
      <div class="skeleton h-6 w-40 mb-2" />
      <div class="skeleton h-6 w-48 mb-2" />
      <div class="skeleton h-6 w-36 mb-2" />
      <div class="skeleton h-6 w-44 mb-2" />
      <div class="skeleton h-6 w-40 mb-8" />

      <div class="skeleton h-6 w-40 mb-2" />
      <div class="skeleton h-6 w-48 mb-2" />
      <div class="mt-auto flex items-center gap-2">
        <RotateCcwIcon
          :size="24"
          class="text-base-content cursor-pointer"
          @click="hotReloadApp"
        />
        <span class="text-sm">{{ VERSION }}</span>
      </div>
    </div>

    <!-- Main content skeleton -->
    <div class="flex-1 p-4 lg:p-6 flex flex-col gap-4">
      <!-- Title skeleton -->
      <div class="skeleton h-8 lg:h-12 w-full max-w-sm lg:max-w-md mb-4 lg:mb-6" />

      <!-- Subtitle skeleton -->
      <div class="skeleton h-6 lg:h-8 w-full max-w-xs lg:max-w-sm mb-4" />

      <!-- Content blocks -->
      <div class="skeleton h-32 lg:h-40 w-full mb-4" />

      <!-- Responsive grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div class="skeleton h-24 lg:h-32 w-full" />
        <div class="skeleton h-24 lg:h-32 w-full" />
        <div class="skeleton h-24 lg:h-32 w-full" />
      </div>

      <div class="skeleton h-40 lg:h-56 w-full" />
    </div>

    <!-- Mobile bottom navigation skeleton (visible on mobile only) -->
    <div class="lg:hidden w-full bg-base-100 p-4 flex justify-around">
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />
      <div class="skeleton h-8 w-8 rounded-full" />
    </div>
  </div>
</template>
